import { Injectable, isDevMode } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { tap } from 'rxjs/internal/operators/tap';
import { Subject } from 'rxjs/internal/Subject';
import { OrdersDaoService } from 'src/app/dao/orders-dao-services/orders-dao.service';
import { Order } from 'src/app/models/orders-model/order.model';
import { UserStorageService } from '../user-storage-service/user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  private refreshOrdersListener = new Subject<any>();

  constructor(private ordersDaoService: OrdersDaoService,
              private userStorageService: UserStorageService) { }

  public getOrders(todayFrom, todayTo) {
    return this.ordersDaoService.getOrders(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), todayFrom, todayTo).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => {
        const orders = new Array<Order>();
        o['data']['orders'].forEach(or => {
          const order = new Order();
          Object.assign(order, or);
          orders.push(order);
        });
        return orders;
      })
    );
  }

  public getOrdersKPI(todayFrom, todayTo) {
    return this.ordersDaoService.getOrdersKPI(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), todayFrom, todayTo).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => o['data']['kpi'])
    );
  }

  public listenRefreshOrders() {
    return this.refreshOrdersListener.asObservable();
  }

  public refreshOrders(from, to) {
    this.refreshOrdersListener.next({ from, to });
  }
}
